import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba5a13a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "stroke-list" }
const _hoisted_2 = { class: "table-container" }

import { ref, } from 'vue';
import BreadcrumbBlock from '../pubilcComponents/breadcrumbBlock.vue';
import TableContainer from './components/tableContainer.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isList = ref<boolean>(true);
const isfull = ref<boolean>(true);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BreadcrumbBlock),
    _createElementVNode("div", {
      class: _normalizeClass(['container', isfull.value ? 'full' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TableContainer, {
          isfull: isfull.value,
          "onUpdate:isfull": _cache[0] || (_cache[0] = ($event: any) => ((isfull).value = $event)),
          isList: isList.value,
          "onUpdate:isList": _cache[1] || (_cache[1] = ($event: any) => ((isList).value = $event))
        }, null, 8, ["isfull", "isList"])
      ])
    ], 2)
  ]))
}
}

})